import { ComboboxExternal, ComboboxItem } from '@round/creatorbase-ui';
import { useClientContentTags } from '@round/creatorbase-helpers/api-hooks';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { useMemo } from 'react';

export type ContentTagItem = ComboboxItem<string>;

type Props = {
    value: ContentTagItem[];
    onChange: (value: ContentTagItem[]) => void;
};

export const ContentTagsExternalFilter = ({ value, onChange }: Props) => {
    const { selectedClientId } = useClientSelect();
    const { tags, isLoading } = useClientContentTags(selectedClientId);
    const tagOptions = useMemo(() => tags?.map((tag) => ({ value: tag.name, label: tag.name })), [tags]);

    return (
        <ComboboxExternal
            multiple
            autoHighlight
            items={tagOptions}
            isItemEqualToValue={(a, b) => a.value === b.value}
            value={value}
            onValueChange={onChange}
            placeholder="Search tags…"
            noItemsFound={isLoading ? 'Loading...' : 'No tags found'}
            isClearable
        />
    );
};
